import React from "react";
import { GoogleMap } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface GoogleMapProps {
  blok?: GoogleMap & SbBlokData;
}

const GoogleMapComponent: React.FC<GoogleMapProps> = ({ blok }) => {
  if (!blok || !blok.embed_url) return null;

  return (
    <div {...storyblokEditable(blok)} className="map map-google">
      <iframe
        title="googleMapForm"
        src={blok.embed_url}
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        className="js-lazy-load"
      ></iframe>
    </div>
  );
};

export default GoogleMapComponent;